<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="136.43" height="139.12" viewBox="0 0 136.43 139.12">
        <g id="Capa_2" data-name="Capa 2">
            <g id="Capa_1-2" data-name="Capa 1">
                <g>
                    <path class="cls-1" d="M44.94,86a1.65,1.65,0,0,1-.32-1.83c.44-1.19.7-2.44,1.09-3.66.15-.47.19-.76-.42-.78a18,18,0,0,0-6.25.8c-1,.32-1.94,1.08-3.11.94-.42,0-1-.13-1,.67,0,.49-.39.29-.6.31a19.74,19.74,0,0,1-2.86.2c-3-.12-6,.48-9,.21-5.43-.5-10.73-1.51-15.41-4.59A16.45,16.45,0,0,1,3.75,75.1a2.73,2.73,0,0,1-.43-2.91c.4-1.08.88-2.13,1.27-3.21a2.82,2.82,0,0,0-.93-3.52,6.33,6.33,0,0,1-1.84-2.89A9.5,9.5,0,0,0,.18,59.28c-.33-.36-.14-.63.05-.94,1.11-1.75,2-3.64,3.25-5.29a3.57,3.57,0,0,0,.19-3.45,7.17,7.17,0,0,1,.17-5.88,13,13,0,0,1,5.74-5.56,25.23,25.23,0,0,1,3.53-1.46,4.26,4.26,0,0,0,2.61-3.81.86.86,0,0,0-.09-.46c-1.64-2-.46-4.18.36-5.85a6,6,0,0,1,4.93-3.06c.85-.07.83-.41.76-1a7.6,7.6,0,0,1,1.13-4.91c1.53-2.49,5.79-4.46,8.67-4,2.49.43,2.76.28,3.61-2.11a30.62,30.62,0,0,0,1.48-5.15,1.61,1.61,0,0,1,1-1.35c.67-.3,1.63-.39,1.62-1.49,0-.06.25-.16.39-.18,2-.23,3.57-1.32,5.27-2.17A12.15,12.15,0,0,1,47.31.22,5.77,5.77,0,0,0,49.07.15c.53-.06,1.08.12,1.6-.13h.47a2.43,2.43,0,0,0,1.68,0h.24a7,7,0,0,1,2.52,1.22c.43.45,1.14.15,1.67-.13s.76-.12.88.37a1.09,1.09,0,0,0,1.2.91.94.94,0,0,1,.93.61c.27.7,1,1,1.34,1.61.77,1.29,2.17,1.54,3.23,2.32.08.26-.1.41-.24.58-.36.69,0,1.1.6,1.28,3.34,1,4.76,4,6.57,6.47.34.47.19,1.14,1.16,1.06.65-.05.87,1,.26,1.43s-.52,1-.05,1.36a10,10,0,0,1,1.83,2c.31.39.69.71.82-.14.09-.66.63-.65,1.08-.67s.34.53.52.76c.93,1.21.8,3,2.32,3.89.7.4.63,1.32.94,2a6.9,6.9,0,0,0,.8,1.55,3.76,3.76,0,0,1,.91,2.76,6.58,6.58,0,0,0,.92,3.18c.46,1,1,2,1.46,3,.16.44.37.87.52,1.33.28.84.26,1.56-.7,2-.36.16-.78.41-.83.8-.19,1.41-1,2.78-.39,4.27a1.46,1.46,0,0,1,.18.8c-.36,1.74.09,3.43.26,5.15.2,1.92-.93,3.48-1.59,5.18-.11.29-.26.58-.39.86-.26.54-.09.82.5.89s.94.18,1.41.22a12.12,12.12,0,0,1,3,1.07c1.2.59,1.32,1.64,1.19,2.8A6.74,6.74,0,0,1,87.67,64c-.28,2.29-1.76,3.81-3.26,5.38-1.29,1.36-3.17,1.85-4.49,3.19a1.88,1.88,0,0,0-.77,1.73,11.87,11.87,0,0,1,.07,2.15c0,.4,0,.9-.32,1.11-1.4.93-1.4,2.66-2.25,3.82-1.44,2-3,4-5.47,4.8-1.09.33-2.09,1-3.32.84a5.26,5.26,0,0,0-1.54.09c-1.32.45-2.49-.27-3.69-.52a9.78,9.78,0,0,1-2.21-.79,2.09,2.09,0,0,0-2.6-.62c-2.09.53-4,1.67-6,2.25a7.42,7.42,0,0,1-5.88-.61A1.9,1.9,0,0,1,44.94,86Z"/>
                    <path class="cls-2" d="M83.05,34.57a6.81,6.81,0,0,1-1-4.45c.12-.61-.38-.74-.61-1a6.33,6.33,0,0,1-1.5-2.8c-.2-1.69-2.41-2.07-2.09-3.88.08-.44-.67-.45-.8-.76a3.37,3.37,0,0,1,0-1.25c-.48.24-1.41-.07-.86,1,.1.19-.15.36-.35.4a1,1,0,0,1-1.07-.34,5.58,5.58,0,0,0-2-2.14c-.46-.25-.36-.85-.46-1.31-.19-.93.45-.38.77-.46s.3-.41.27-.69c-.37.07-.52-.78-.84-.33s-.61.31-.89.15-.19-.48,0-.72a.37.37,0,0,0,0-.52,29.35,29.35,0,0,0-4.58-5.6A6.39,6.39,0,0,0,65,9.06c-.85-.34-1.31-.88-.69-1.81a1.14,1.14,0,0,0,.66,0A.68.68,0,0,0,64.77,7c-.56-.14-1-.67-1.69-.45a.6.6,0,0,1-.48-.29C62.16,4.82,60.26,4.56,60,3a.4.4,0,0,0-.53-.33C58.16,3,57.88,2.22,57.83,1c-.47.72-1.07.62-1.6.77-.86.26-.89-.57-1.29-.74a7.64,7.64,0,0,1-1.88-1q41.19,0,82.39,0c.82,0,1,.16,1,1q0,37.49,0,75a.4.4,0,0,1-.5-.23c-.85-1.73-2.38-2.85-3.71-4.17a7.38,7.38,0,0,1-2.43-4.87,13.61,13.61,0,0,0-1.63-5.63c-.12-.21-.2-.5-.4-.58-1.42-.61-2.22-2-3.56-2.73a5,5,0,0,0-1.56-.59,8.49,8.49,0,0,1-4.26-2.49.57.57,0,0,1-.26-.63c.37-.9-.18-1.51-.63-2.17a6.07,6.07,0,0,1-.58-1.3,8.12,8.12,0,0,0-4-4.6c-1.52-.79-3.06-1.54-4.59-2.31a2.87,2.87,0,0,1-1.6-4l0-.11c1.31-2.46.29-3.51-2-4.63s-4.62-.71-6.81.27a2.05,2.05,0,0,1-2.8-.64,4.16,4.16,0,0,0-2.69-1.38c-2.77-.52-5.17.37-7.66,1.15C84.21,34.44,83.68,34.81,83.05,34.57Z"/>
                    <path class="cls-3" d="M83.05,34.57,86.9,33.3a11.65,11.65,0,0,1,4.8-.56,5,5,0,0,1,4,1.91c.55.72,1.11.64,1.85.31,2.32-1.05,4.68-1.51,7.16-.44a7,7,0,0,1,2.57,1.89,2,2,0,0,1,0,2.51c-.78,1.14-.31,2.32-.47,3.47,0,.36.51.45.81.61,2.17,1.1,4.42,2.07,6.47,3.35a7.23,7.23,0,0,1,3,3.68,6.1,6.1,0,0,0,1.3,2.51.83.83,0,0,1,.1,1.19c-.46.59-.18.73.42.94.83.3,1.12,1.35,2.07,1.61a11.25,11.25,0,0,0,1.45.5A7.21,7.21,0,0,1,125.1,58c1,.58,1.43,1.7,2.68,2,.68.19.81,1.39,1.14,2.16a17.18,17.18,0,0,1,1.25,5.44c.15,1.78,1.38,3,2.63,4.13A15.1,15.1,0,0,1,136.41,76v.72c-.6,1.2-1.2,2.4-1.78,3.61a1.41,1.41,0,0,0-.16.81c.51,2,.1,4-.15,6.07,0,.16,0,.3-.12.4-1,.89-1.31,2.26-2,3.34-.56.84-.92,2-2.35,1.68-.1,0-.25.17-.38.26-1.58,1.08-3.14,2.21-5.21,2.08-.14,0-.28.14-.42.2a8.09,8.09,0,0,1-3.25.71c-1.23,0-2.47-.2-3.61.72-.68.56-1.69.29-2.55.1-1.5-.32-3-.68-4.23.67-.2.22-.42.09-.66,0a19.29,19.29,0,0,0-3.85-.76c-2.06,0-4-.74-6-.87a4.06,4.06,0,0,0-2.21.38,6.18,6.18,0,0,1-3.71.58,9.26,9.26,0,0,0-3.92.16c-.64.2-1.1.49-.89,1.37a14,14,0,0,1,.33,3A3.29,3.29,0,0,1,87,104.5c-.14,0-.25.14-.43.07-1.94-.74-4.12-.94-5.7-2.51,0,0-.16,0-.24,0a7.67,7.67,0,0,1-3.49-3.58c-.31-.58-.58-.67-1.21-.46a6.31,6.31,0,0,1-4.58-.42,2.36,2.36,0,0,1-1.54-1.95c-.2-.83-.69-1.63-.22-2.53.13-.24.31-.52.06-.77-.86-.83-.12-1.25.43-1.68a12.46,12.46,0,0,1,1.57-.85c.57-.31.53-.6,0-1a4.36,4.36,0,0,0-2.18-.49c-.9-.08-1.59-.43-1.58-1.5,2.6-.57,5.1-1.3,6.79-3.6a13.71,13.71,0,0,1,1.22-1.31c.33-.36.95-.61.45-1.26,0,0,0-.08,0-.11.29-.7,1.34-1.11.82-2.14-.07-.14.19-.34.41-.36C78.94,77.94,79,77,79,76c0-.55-.1-1.11-.15-1.66-.08-.89,0-1.66,1-2a3.4,3.4,0,0,0,1.34-1.16,1.82,1.82,0,0,1,1.53-.78.6.6,0,0,0,.45-.08c1.6-2,3.93-3.48,4.18-6.36.18-.09.36-.33.52-.25,1.08.57,1.62-.23,2.19-.87a16,16,0,0,0,2.26-2.59,5.84,5.84,0,0,1,2.43-2.66A20.81,20.81,0,0,0,97.67,55a13.73,13.73,0,0,0,2.49-2.72,15.31,15.31,0,0,1,3-3.07,11.44,11.44,0,0,0,1.55-1.48c.29-.36.69-.93.27-1.25s-.67.34-1,.61a23.56,23.56,0,0,0-3.6,4.61A6.1,6.1,0,0,1,98,53.77a30,30,0,0,1-4.18,1.75,8,8,0,0,0-4.6,3.23c-.1.17-.24.4-.41.4a3.94,3.94,0,0,0-2.23,1l-3-1a2.07,2.07,0,0,1,2.24-2.65c.29,0,.57.14.75-.14.62-.93,1.63-1.46,2.25-2.42,1.18-1.83,3-3,4.57-4.53a4,4,0,0,0,1-1.43c.46-1.11,1.62-1.61,2.42-2.43.57-.6,1.25-1,1.41-2a2.41,2.41,0,0,1,.9-1.24c.47-.43.89,0,1.34.06s1.21-.37,1.53.47a2.24,2.24,0,0,1-.21,1.62c.57,0,.52-.32.46-.61a8,8,0,0,1,.37-4.8c.1-.24.31-.58,0-.75s-.65.09-.77.38c-.76,1.75-2.26,2.16-4,2.4-1.21.17-2.07,1.13-3.06,1.79-.23,2.23-2.65,2.18-3.76,3.53-.47.57-1.64.46-2.49.62-.62.11-.57-.54-.41-1a5.25,5.25,0,0,1,2-2.74c2.18-1.3,2.14-3.48,2.45-5.53a1.6,1.6,0,0,0-1-1.55A3.89,3.89,0,0,0,88,36.08c-.76.35-1.49.76-2.25,1.11-.38.18-.76.5-1.23.23Z"/>
                    <path class="cls-4" d="M48.94.23a1.21,1.21,0,0,1-1.63,0V0H49c.08.07.1.12.06.16A.14.14,0,0,1,48.94.23Z"/>
                    <path class="cls-5" d="M52.82,0a1.35,1.35,0,0,1-1.68,0Z"/>
                    <path class="cls-6" d="M48.94.23C49,.16,49,.09,49,0h1.68C50.14.47,49.52.2,48.94.23Z"/>
                    <path class="cls-7" d="M67.89,86.85c.44,1.52,1.86,1.3,2.86,1.32.77,0,1.06.52,1.55.75.64.31.2.77-.27,1a9.41,9.41,0,0,0-2.27,1.28c-.24.25-.77.59.1.75.51.09.55.42.24.78A2,2,0,0,0,69.89,95a4.86,4.86,0,0,1,.41,1.49c0,.18.09.49.19.52,1.92.52,3.79,1.69,5.84.48.25-.14.55-.34.69.07.66,1.93,2.23,3.12,3.59,4.47.19.52.36,1,.56,1.57a4.62,4.62,0,0,1,.37,2c-.16,2.32-.93,2.93-3.17,2.49a5.4,5.4,0,0,1-.82-.15c-.7-.25-.83.09-.83.69A9,9,0,0,0,77.87,113a15,15,0,0,1,1.72,5.32,29.38,29.38,0,0,1-.22,11,11.12,11.12,0,0,1-3.5,6.37,1.73,1.73,0,0,1-1.86.38c-.38-.14-.78-.19-1.14-.35a2.58,2.58,0,0,0-3.48.82c-.92,1.19-2.62,1.32-3.66,2.42-.2.22-.45,0-.66-.08a14.17,14.17,0,0,1-2.69-1.28,3.39,3.39,0,0,0-3.62-.3c-2.11.93-3.81.15-5.4-1.11a10.3,10.3,0,0,1-2.85-3.8c-1-2.12-1.87-2.41-4-1.64a4.36,4.36,0,0,1-5.06-2.51,1.67,1.67,0,0,0-2-1.33c-2.78.11-5.52-2.76-5.52-5.62,0-2.09,0-2.1-2-2.67a6.75,6.75,0,0,0-1.52-.32c-2.05,0-3.18-1.24-4-3-.34-.76-.89-1.42-1.26-2.17a8.43,8.43,0,0,1-1-6.49.76.76,0,0,1,.63-.59l.08.09c.32.37-.27,1.17.38,1.22s.84-.69,1.06-1.36a1.5,1.5,0,0,1-1.54.07c-.08-.43-.15-.85-.25-1.27,0-.14-.22-.3-.06-.42.91-.71,1-2.06,2-2.67s.93-1.55,1.27-2.42c.2.27.23.66.67.56s.54-.44.64-.78a7.25,7.25,0,0,1,4.33-4.57h.11c-.06-1.24.7-.64,1.33-.77.88-.17,1.38-1.21,1.9-2s-.54-.45-.73-.77c-.07-.64.6-.21.76-.53,1.09-.79,2.17-1.61,3.23-2.43C41.5,87,43.36,86.84,44.94,86a8.46,8.46,0,0,0,5.42,1.43,17.83,17.83,0,0,0,4.51-1.49,16.26,16.26,0,0,1,3-1.09,9.11,9.11,0,0,1,2.57.67c.77.39,1.8.16,2.41,1,.13.18.36,0,.54-.07s.48-.22.54-.16C65.11,87.6,66.62,86.39,67.89,86.85Z"/>
                    <path class="cls-8" d="M36.77,90.54c-.12.38-.62.19-.76.53C35.81,90.24,36.52,90.73,36.77,90.54Z"/>
                    <path class="cls-2" d="M62.34,54.87c.11-1.07-.67-1.62-1.36-2.13-.25-.19-.31-.42-.47-.61-.44-.51-.81-1.07-1.61-1.06-.5,0-.83-.42-1.24-.66-.69-.42-.8-1.83-2.13-1.25-.16.07-.41-.57-.41-.9a.74.74,0,0,0-.65-.83l0,0a1.15,1.15,0,0,0-.3-.88A16.58,16.58,0,0,0,51.7,44a19.91,19.91,0,0,1-3.26-3.68c-.41-.56-.82-1.1-1.63-1a.63.63,0,0,1-.54-.17,48,48,0,0,0-6.2-4.53,5.24,5.24,0,0,1-2.24-2.42c-.26-.71-.64-1.72-1.89-1-.47.26-.4-.29-.37-.58s0-.62-.44-.72-.5.08-.55.41-.31.4-.6.2a16.76,16.76,0,0,1-2.75-1.89c-.44-.48-.94-.94.24-1.24s1.31-.92.72-2A9.06,9.06,0,0,0,30,22.93a15.05,15.05,0,0,1-2.67-2.56,2.46,2.46,0,0,1-.4-2.55A16.26,16.26,0,0,0,28,19.08a6.65,6.65,0,0,0,4.51,2.14c1.14,0,1.84.65,1.67,2.07a3.51,3.51,0,0,1-.31,1.8c-.38.6.34.21.51.34s.07.35.27.43c.75.77,2.05.44,2.76,1.36.18.23.76.15.67-.43-.2-1.23.69-.83,1-.55.77.62,2,.65,2.48,1.29,1.21,1.44,3,2,4.29,3.24.21.2.67.54-.12.64-.35,0-.34.4-.35.67s.32.27.53.32a5.86,5.86,0,0,0,.82.14,2,2,0,0,1,2,2c0,.7.33,1.18.82,1.25s1.05-.6,1.07-1.07c.05-1.39.78-2.7.41-4.12-.15-.55-1.44-1.41-1.87-1.09s-.25.76,0,1.14.77.7.78,1.32a3.15,3.15,0,0,1-2.48-2.9c-.24-1.16-.32-2.59-1.91-3.15,0,.55.2,1.08-.15,1.51s-.31,1.12-1,1a1.59,1.59,0,0,1-1.14-1.13c-.21-.64.39-.87.82-1.14s.63-.34.94-.52c.14-.08.39-.21.38-.25-.26-.91,1-1.69.21-2.62-.32-.34-1,.09-1.17-.5-.26-.78-1.41-.72-1.51-1.64.13-.83.94-.1,1.24-.53l.14-.19c.83.65,1.81.41,2.73.54s1.37,1,1.63,1.76a4.56,4.56,0,0,0,3.41,3.15c.35.09.64.17.65.52,0,1.86,2,2.58,2.43,4.3.18.79.76.37,1-.37a3.17,3.17,0,0,1,.2,2c0,.44-.1,1,.37,1.15,1.06.24,1.22.94,1.33,1.83a4,4,0,0,0,1,2,2.5,2.5,0,0,1,.77,2.6c-.09.25.22.4.33.6.41.74,1.87,1,1.11,2.32-.13.25.53.35.82.52s1.09.22.1.62c-.37.14-.26.53,0,.64.73.27.86.91,1,1.52.07.33.32.39.47.59.51.68.74,1.59,1.74,1.87.16,0,.16.63.24,1a7.5,7.5,0,0,0-2.29.24c-.11.09-.19.07-.25,0-.57-.47-.57-.47-2.58-.39l2.52,5.88A.52.52,0,0,1,62.34,54.87Z"/>
                    <path class="cls-2" d="M63.13,37.13c-.35-.83-.63-1.7-1.05-2.5a76.32,76.32,0,0,0-4.38-8.06C56,24,54.64,21.1,52.23,19a5.52,5.52,0,0,1-1.81-2.9.68.68,0,0,0-.53-.55c-.56-.21-.75-.46-.62-1.22.16-1-1.11-1.43-1.65-2.19-.2-.26-.55-.39-.65-.79-.17-.7-.27-1.67-1.35-.69-.07.07-.4,0-.43-.05-.43-.87-1.32-1.54-1.26-2.63a6.7,6.7,0,0,1,2.29-2.23,6.82,6.82,0,0,0,2.43-.49c1.39-.93,1.82.32,2.42.91a18.78,18.78,0,0,1,3.8,5.47,8.46,8.46,0,0,0,2.34,3c.35.28.1.46.17.66a9,9,0,0,0,1.75,3.13,19.39,19.39,0,0,1,1.76,3A2.9,2.9,0,0,1,61.36,24c-.16.41.13.59.34.81a4.94,4.94,0,0,1,1.38,2.34A6.48,6.48,0,0,0,65.91,31c.12.09.3.23.3.33-.11,1.82,1.39,3.48.53,5.37-.09.2-.21.69.21.65,1-.1.77.66.91,1.16.37,1.26.71,2.53,1.1,3.78A12.48,12.48,0,0,1,69.51,45c.1,1.56-.09,1.76-1.59,1.75a.18.18,0,0,1-.27,0c-2.3-2.06-1.8-5.46-3.79-7.77.46-.14,1.09,0,1.06-.55s-.59-.2-.87-.37c-.13-.08-.29-.13-.43-.2a1.26,1.26,0,0,1-.12-.42.4.4,0,0,0-.26-.25Z"/>
                    <path class="cls-2" d="M84.47,37.42l3.11-1.52a4.37,4.37,0,0,1,4.33.07c.5.29,1,.69,1,1.26-.17,1.91.19,4-1.53,5.49A9,9,0,0,0,88.52,46c-.11.29-.45.58-.14.85s.53-.17.78-.31.2-.22.28-.21c1.77.19,2.65-1.28,3.94-2,.73-.4,1.58-.27.8-1.38a.61.61,0,0,1,.18-.14c1.34-.69,2.3-2,4-2.14a3.24,3.24,0,0,0,3.18-2.11,1,1,0,0,1,.83-.78,1.43,1.43,0,0,1,.8.11c.33.21,0,.5-.07.73-.65,1.78-1.15,3.55-.35,5.44.24.55-.53.91-1.6.71a9.84,9.84,0,0,0,.63-1,1.1,1.1,0,0,0-.2-1.23c-.33-.44-.53,0-.76.18a.47.47,0,0,1-.54,0c-.28-.14-.45-.76-.81-.43s-1.1,1.06-1,1.5c.12.7-.3.85-.6,1.13-1,1-2.6,1.67-3,2.82-.6,1.68-2,2.26-3,3.36a20.11,20.11,0,0,0-2.93,3.13c-.6,1-1.85,1.4-2.25,2.56a.43.43,0,0,1-.47.27c-2.05-.25-2.21-.21-2.54,2-2.72-.24-2.71-.23-1.64-2.66a14.68,14.68,0,0,0,1.44-3.78,4.17,4.17,0,0,0-.32-2.8,2.07,2.07,0,0,1-.07-1.72,3.54,3.54,0,0,0-.32-3c-.09-.12-.23-.35-.19-.4.84-1,.41-2.23.69-3.32a1.45,1.45,0,0,1,1.19-1.06c.85-.18.86-.65.62-1.31S84.66,38,84.47,37.42Z"/>
                    <path class="cls-2" d="M75.6,48.19a5.53,5.53,0,0,0-.83-3.41c-.08-.11-.1-.4-.14-.4-1.46.08-1.14-1.17-1.35-1.9-1-3.68-1.61-7.47-3-11.06a25,25,0,0,0-1.75-3.79,2.79,2.79,0,0,1-.67-2.2c.09-.35-.17-.59-.41-.82s-.44-.36-.43-.54c0-1.63-1.2-2.69-1.75-4a49.94,49.94,0,0,0-4.37-8.28,1.11,1.11,0,0,1-.1-.35c.68-.24,1.45.09,2-.49.31-.31.54.13.59.32a5.36,5.36,0,0,0,1,2c.79,1,1.43,2.16,2.2,3.21a1.11,1.11,0,0,0,1.11.54c.22-.27,0-.45-.14-.62-.36-.45,0-.73.3-.85s.44.24.52.48a5.88,5.88,0,0,1,.18.93c0,.28.06.67.42.59,1-.21,1.13.64,1.42,1.24,1.37,2.82,2.7,5.67,4.1,8.49,1.89,3.8,2.61,8,4.19,11.91.1.66-.4,1-.78,1.33.45,0,.91.06,1.07.62a9.48,9.48,0,0,1-1.11,2.57,10.8,10.8,0,0,0-.88,3.06,2.29,2.29,0,0,1-.5,1.33C76.29,48.36,76,48.72,75.6,48.19Z"/>
                    <path class="cls-2" d="M10,40.79a5.9,5.9,0,0,1,3.87.28C24,44.52,34.11,48.16,43.46,53.58A68.06,68.06,0,0,1,57.54,64c-.74.41-.77.44-1.34,0-1.24-.9-2.7-1.5-3.58-2.87a4.42,4.42,0,0,0-1.77-1.39,1.74,1.74,0,0,0-2.38.25c-.63.72-1.21.67-1.87,0a8.26,8.26,0,0,0-1.52-1.16,2.1,2.1,0,0,0-3.16.54c-.49.57-1.81.56-2.1-.1S39,58.43,38.6,58c-.25-.23-1.15-.36-.17-.9.23-.13.06-.69-.22-.83-.68-.34-1.13-1.38-2.21-.61-.56.4-2.86-1-2.92-1.67,0-.53-.33-.66-.72-.78-.61-.18-1.23-.35-1.83-.57-.36-.14-.87-.41-.72-.82.42-1.14-.39-.86-.94-.92a8.36,8.36,0,0,1-3.62-1.45,15.73,15.73,0,0,0-4.37-2.42c-.42-.11-.64-.47-.89-.76a15.71,15.71,0,0,0-3.9-3.13c-1-.58-1.91-1-2.89.06-.5-1.5-1.93-1.53-2.92-2.19C10,41.11,9.94,41,10,40.79Z"/>
                    <path class="cls-2" d="M40.13,41c.51.12,1.1.17.93,1-.2.25-.08.48,0,.72.3.31.35.82,1.1.35.54-.34.89.66,1.31,1.07.06.22,0,.32-.24.24a2.35,2.35,0,0,1-.43-.19c-.78-.52-1.08-.37-.61.87a7.78,7.78,0,0,0-3.55-2c-.41-.08-.26-.63-.22-.95.11-.81-.12-1.16-1-1.11a3.48,3.48,0,0,1-3-1.55,6.69,6.69,0,0,0-3.1-2.09A6,6,0,0,1,29.07,36a18.15,18.15,0,0,0-3-2.5,8,8,0,0,1-3.21-3.43c-.28-.71-1.19-.89-1.83-1.71a3.78,3.78,0,0,1,2.85,1c.12.07.12.44.42.41,1.4-.16,2.43,1,3.78,1.07a3,3,0,0,1,2.15,1.33,14.22,14.22,0,0,0,4.23,3.27A16.11,16.11,0,0,1,39,39a5.53,5.53,0,0,1,.91,1.53C39.7,40.79,39.89,40.9,40.13,41Z"/>
                    <path class="cls-2" d="M47.64,66.75a36.43,36.43,0,0,1-6.66-1C33.86,64.19,26.77,62.54,19.65,61c-2.65-.58-5.34-.93-7.86-2.59,6.23,1,12.28,1.87,18.32,2.87A58,58,0,0,1,47.64,66.75Z"/>
                    <path class="cls-2" d="M86.61,60.18c.06,0,.18-.08.19-.14.17-1,.75-1.26,1.65-1,.29.09.35-.13.43-.28C90,56.74,92,55.92,94,55.15a26.39,26.39,0,0,0,4.16-1.8,5.74,5.74,0,0,0,2.12-2.06c.47-.81,1.23-1.51,1.63-2.21.58-1,1.54-1.57,2.06-2.48.42-.74,1-.85,1.4-.51s0,1-.17,1.56c0,.07-.11.12-.17.16-3.47,2.6-5.73,6.42-9.14,9.09a10.21,10.21,0,0,0-1.14,1.22c-.08.08-.16.27-.22.26-1.17-.11-1.26.64-1.6,1.54s-1.38,1.62-2.1,2.42a11.74,11.74,0,0,1-.86,1c-.59.53-1.06,1.7-2.08.49-.06-.07-.37.08-.56.12C88,62.09,87.76,61,86.61,60.18Z"/>
                    <path class="cls-9" d="M54.29,51.74c.44,0,1,.2.87.69a.86.86,0,0,1-1.18.44c-.37-.16-.76-.37-.79.35,0,.37-.35.17-.54.12-.41-.12-.79-.42-1.23-.1a.26.26,0,0,1-.31,0c-1.55-1.29-3.41-2.15-4.83-3.64-1.25-1.3-1.31-1.23-.12-2.56a7.1,7.1,0,0,1-2.68-.86.14.14,0,0,1,0-.15s0-.07.06-.07c.9.2.93-.27.71-.93-.08-.06-.1-.11-.08-.17s.05-.08.08-.08l.51.29c.24.12.51.4.76.19s-.2-.51-.14-.86c.44,0,1.15.42,1.16-.57,0-.07.69-.32.79-.06.18.51,1,.57.79,1.37-.33,1-.46,2.06,1,2.46a.58.58,0,0,1,.44.72,1.36,1.36,0,0,0,1.57,1.73c.4,0,.45,0,.27.56-.26.79.41.95.69.69.61-.56,1,0,1.53,0A1,1,0,0,1,54.29,51.74Z"/>
                    <path class="cls-10" d="M67,69.27a8.69,8.69,0,0,1-2-2.12,8.14,8.14,0,0,0-4.28-4c-.52-.17-.7-.63-.94-1a10.85,10.85,0,0,0-4.49-4.34c-1.12-.54-1.24-1.73-2-2.6a1.83,1.83,0,0,0,2.35-.58c.25-.32.47-.14.68.09L59,57.59c-1.1,0-1.26-1.27-2.17-1.16.53,2,1.61,2.92,3.39,2.8.32,0,.4.19.56.33a7.32,7.32,0,0,1,2.64,4.2c0,.11,0,.33,0,.33,1.68.08,1.21,2.29,2.76,2.69C67.16,67.05,66.6,68.44,67,69.27Z"/>
                    <path class="cls-3" d="M75.6,48.19c.3.2.51.09.69-.18a3.16,3.16,0,0,0,.51-1.45,5.43,5.43,0,0,1,.84-2.87c.5-.71.44-1.81,1.26-2.44,0,0,0-.15,0-.23-.13-.24,0-.26.2-.26,0,.92.46,1.88-.34,2.76-.19.21.16.89.24,1.36.76,4.37-.89,8-3.51,11.34,0,0-.14,0-.27,0a17.2,17.2,0,0,0,.51-2.06c.06-.55.67-1.3-.42-1.62-.24-.06-.18-.35.08-.54a1.66,1.66,0,0,0,.35-2.44A2.26,2.26,0,0,1,75.6,48.19Z"/>
                    <path class="cls-11" d="M21.23,70.24A155.42,155.42,0,0,0,40.11,72.4c1.41,0,2.5.94,3.88,1.47a3,3,0,0,1-2.36.33c-3-.79-6.09-.57-9.11-1.28-3.71-.87-7.52-1.38-11.28-2A.39.39,0,0,1,21.23,70.24Z"/>
                    <path class="cls-12" d="M28.07,74.55A80.77,80.77,0,0,1,20,73.68a1.38,1.38,0,0,1-1.3-1c.61.06,1.19.11,1.76.18.34,0,.73.26.81-.34,0-.27.26-.26.46-.24,1.23.15,2.45.33,3.68.46.42,0,.28.41.42.61.3.39.48.82,1.21.43.58-.31,1.15.52,1.83.49C28.74,74.86,28.36,74.55,28.07,74.55Z"/>
                    <path class="cls-13" d="M52.76,1.19c1.29-.08,2.08.79,3.14,1.27-.3.33-1.35-.08-.79.82a13.18,13.18,0,0,0,1,1.18c-2.34.79-2.92-1.54-4.39-2.35C52.27,2,53.52,2.86,52.76,1.19Z"/>
                    <path class="cls-13" d="M14,48.4c.34-.16,1.23.49.86-.72l2.94,1.7c-.77.57-1.72.8-2.3,1.85-.1-1.33-1.14-1.87-1.5-2.83Z"/>
                    <path class="cls-14" d="M9,46c.8.15,1.85-.21,2.13,1.06.06.24.48.47.68.32.61-.47.83.16,1.2.35l.14.13-.18.05c-1.72.66-2.62.22-4-1.94Z"/>
                    <path class="cls-15" d="M61,67.58c1.61.73,2.48,2.23,3.81,3.51a2.39,2.39,0,0,1-2.32-1.25,3.32,3.32,0,0,0-1.55-1.3A1.19,1.19,0,0,1,61,67.58Z"/>
                    <path class="cls-16" d="M68,56.64l-.68-3.23c.89.08,1,1,1.29,1.42C69.08,55.54,68.57,56.14,68,56.64Z"/>
                    <path class="cls-17" d="M35.08,75.22,32.68,75c.88-1,1.83-1.06,2.6-.33C35.23,74.86,35.3,75.09,35.08,75.22Z"/>
                    <path class="cls-18" d="M19.76,70.4c-1.18.06-2.37.19-3.29-1L20,70C20.13,70.26,19.91,70.31,19.76,70.4Z"/>
                    <path class="cls-19" d="M24.22,56.16c.89-.22,1.6-.56,2.34-.14.2.12.4.28.34.56s-.3.23-.47.22A2.74,2.74,0,0,1,24.22,56.16Z"/>
                    <path class="cls-20" d="M43,41.65l2,1.46a.55.55,0,0,1,.1.84c-.28.31-.48-.09-.65-.25-.57-.59-1.11-1.2-1.67-1.81Z"/>
                    <path class="cls-21" d="M9,45.94c-.91.07-.91.07-.81.91C7,46,6.75,45.37,7.44,44.09c0,1.16.78,1.53,1.57,1.88Z"/>
                    <path class="cls-22" d="M79.1,40.76l-.2.26c-.32-.48-.87-.18-1.34-.36l1.19-1.5C78.87,39.69,79,40.22,79.1,40.76Z"/>
                    <path class="cls-23" d="M28.07,74.55c.26-.09.58,0,.79-.24a20.37,20.37,0,0,1,3.31.41l0,.3Z"/>
                    <path class="cls-24" d="M69.38,57.46c.62.2.39.94,1,1.14.25.08-.15.52-.35.72s-.39,0-.48-.24A1.76,1.76,0,0,1,69.38,57.46Z"/>
                    <path class="cls-25" d="M60.46,85.52a4.23,4.23,0,0,1-2.57-.67A1.93,1.93,0,0,1,60.46,85.52Z"/>
                    <path class="cls-26" d="M70.37,56.74a2.25,2.25,0,0,1-.68-2.3C70.63,55.05,70.32,55.94,70.37,56.74Z"/>
                    <path class="cls-27" d="M44.46,22.3c.33.31.9,0,1.17.5-.32,0-.65-.27-.92.2-.37.64-.41.62-1.09,0C43.7,22.55,44.59,23,44.46,22.3Z"/>
                    <path class="cls-28" d="M42.77,21.42c-.28.29-.33.9-.92.57-.22-.12-.67-.43-.41-.7S42.3,21.17,42.77,21.42Z"/>
                    <path class="cls-17" d="M19.33,79.72c.44.11,1-.08,1.39.35-.69.48-1.29.17-1.89-.07C18.79,79.54,19.09,79.69,19.33,79.72Z"/>
                    <path class="cls-29" d="M54.47,47.43l-.25,1a1.7,1.7,0,0,1-.88-1.06c.43-.23.77.2,1.15.08Z"/>
                    <path class="cls-30" d="M54.29,51.74l-.75-.4c.71-.11.13-.64.29-.93C54.54,50.75,54.54,50.75,54.29,51.74Z"/>
                    <path class="cls-31" d="M10,40.79l.32.24L9,41.72c-.26.06-.35,0-.29-.29A1.88,1.88,0,0,1,10,40.79Z"/>
                    <path class="cls-32" d="M40.13,41c-.4.51-.57,0-.81-.18s-.22-.28-.1-.41c.28-.31.45.22.72.12C40.15,40.61,40.14,40.8,40.13,41Z"/>
                    <path class="cls-33" d="M41.09,42.65a5.3,5.3,0,0,1-.43-.38c-.12-.14-.35-.29-.19-.48s.39.1.59.14C41.68,42.15,41.34,42.4,41.09,42.65Z"/>
                    <path class="cls-34" d="M19.76,70.4,20,70c.45-.09.82.18,1.24.25v.63C20.85,70.37,20.28,70.46,19.76,70.4Z"/>
                    <path class="cls-35" d="M8.74,41.43l.29.29c-.26.27-.3.87-.93.62A1.15,1.15,0,0,1,8.74,41.43Z"/>
                    <path class="cls-36" d="M59.33,55.9c.55,0,.81.25.89.81C59.6,56.7,59.52,56.23,59.33,55.9Z"/>
                    <path class="cls-37" d="M58.8,79.18a1.15,1.15,0,0,1-1.4-.26C58,78.76,58.36,79.09,58.8,79.18Z"/>
                    <path class="cls-38" d="M24,56.18a1.31,1.31,0,0,1-.4.1c-.14,0-.37,0-.29-.25s.24-.16.38-.18S24,55.9,24,56.18Z"/>
                    <path class="cls-39" d="M44.19,20.13c-.25.56-1,0-1.24.53-.22-.16-.52-.38,0-.5A5.78,5.78,0,0,1,44.19,20.13Z"/>
                    <path class="cls-40" d="M34.65,25.86c-.21-.07-.25-.24-.27-.43.23-.18.43-.43.85-.29C35.26,25.57,34.39,25.31,34.65,25.86Z"/>
                    <path class="cls-41" d="M44.2,44.8v.25l-.94-.74.24-.24A1.29,1.29,0,0,1,44.2,44.8Z"/>
                    <path class="cls-23" d="M47.83,4.26c.23-.34.43-.5.72-.34.08.05.18.24.15.28C48.47,4.51,48.17,4.35,47.83,4.26Z"/>
                    <path class="cls-42" d="M62.34,54.87l.73,0a1,1,0,0,1-.89.52C62.12,55.36,62.15,55,62.34,54.87Z"/>
                    <path class="cls-43" d="M63.13,49.35l.25,0-.1.78c-.1,0-.23,0-.29-.12C62.76,49.78,63.08,49.58,63.13,49.35Z"/>
                    <path class="cls-44" d="M64.77,7a.62.62,0,0,1,.55.36.89.89,0,0,1-1-.11Z"/>
                    <path class="cls-45" d="M35.08,75.22l.2-.55.56.71C35.53,75.58,35.33,75.28,35.08,75.22Z"/>
                    <path class="cls-46" d="M13,47.88a.24.24,0,0,1,0-.18c.51,0,1,0,1,.7h0C13.66,48.25,13.42,47.87,13,47.88Z"/>
                    <path class="cls-47" d="M67.65,46.72h.27l0,.63c-.13-.07-.3-.1-.39-.2S67.54,46.85,67.65,46.72Z"/>
                    <path class="cls-48" d="M55.94,78.61c.37,0,.76-.13,1.12.35L56,78.79c-.08,0-.11-.06-.09-.11S55.92,78.61,55.94,78.61Z"/>
                    <path class="cls-16" d="M43.49,46a1.62,1.62,0,0,1,0,.22c-.32-.06-.69,0-.93-.34A.7.7,0,0,1,43.49,46Z"/>
                    <path class="cls-49" d="M19.33,79.72c-.17.08-.42,0-.5.28a.65.65,0,0,1-.55-.37A1,1,0,0,1,19.33,79.72Z"/>
                    <path class="cls-50" d="M51.11,53.26l.31,0c0,.23.53.46.14.62S51.17,53.54,51.11,53.26Z"/>
                    <path class="cls-27" d="M60.08,10.06c-.41,0-.33-.36-.47-.55.09,0,.24-.15.26-.13C60,9.57,60.24,9.76,60.08,10.06Z"/>
                    <path class="cls-51" d="M55.94,78.61l0,.18-.91-.33C55.49,78.3,55.74,78.29,55.94,78.61Z"/>
                    <path class="cls-52" d="M63.82,37.37l-.2.46c-.35-.1-.59-.28-.49-.7l0,0C63.41,37,63.61,37.21,63.82,37.37Z"/>
                    <path class="cls-53" d="M61,67.58l-.06,1a1.09,1.09,0,0,1-.11-1s.07,0,.09,0S60.94,67.55,61,67.58Z"/>
                    <path class="cls-54" d="M75,19.71c-.36.1-.46.17-.54.14s-.12-.14-.19-.21c.09,0,.18-.12.26-.11A1.85,1.85,0,0,1,75,19.71Z"/>
                    <path class="cls-2" d="M93.43,69.76,92,70.9c-.12.1-.3.31-.36.28-1.39-.69-1.15.37-1.25,1.12a1.53,1.53,0,0,1-1.49,1.42,3.89,3.89,0,0,0-2.55,1.44,1,1,0,0,1-1.21.45c.37-.39.72-.73,1-1.11.59-.7.56-.76-.19-1.36-.08-.06-.17-.23-.14-.3.6-1.22.91-2.61,2.15-3.46,1-.7,1.89-1.52,1.72-3a.77.77,0,0,1,.61-.78c2.33-.38,2.82-.81,3.29-3,.06-.31.22-.25.39-.29,2-.53,3-2.38,4.47-3.66.61-.54-.49-.47-.78-.79.31-.22.4-.8,1-.43.33.2.5-.15.68-.33a43,43,0,0,1,5.2-3.8A9.09,9.09,0,0,0,107,51.7a25.08,25.08,0,0,1,1.81-1.91,2.94,2.94,0,0,1,3.21-1,2.9,2.9,0,0,1,2,2.83c0,.6.1,1.19.1,1.79a3.22,3.22,0,0,0,1.8,3.23,1.38,1.38,0,0,1,.31,2.24,5.45,5.45,0,0,1-1,.83c-.3.2-.59.66-1,.44s-.14-.68-.06-1.06c.14-.73-.64-.94-.93-1.42-.43-.73-.8-.4-1.32-.1a2.47,2.47,0,0,1-2.2,0,3,3,0,0,0-3.76.9,2.66,2.66,0,0,1-.71.63c-2.27,1.18-4,3-6,4.6a74.19,74.19,0,0,1-6.4,4.62c-.68.42-.87.74.1,1C93.11,69.35,93.26,69.6,93.43,69.76Z"/>
                    <path class="cls-2" d="M108.87,85.3a35.35,35.35,0,0,1,9.63-2.19,2.66,2.66,0,0,1,2.11.55c.35.31.94.63,1-.31.06-.49.52-.47.82-.46a32.33,32.33,0,0,0,6.86-.69c1.44-.24,1.77.28,1.78,1.77s-1.09,2.38-1.48,3.62c-.67,2.18-2.5,2.46-4.29,2.58a21.84,21.84,0,0,1-6,0,.6.6,0,0,0-.41.15c-1,.86-2.28.9-3.48,1.14s-2.31.25-3.23,1.09c-.26.24-.61.14-.92.12l-4.68-.23c.06-.56.53-.72.81-1s.78-.61.77-1c0-1.82,1.33-1.6,2.41-1.77a6.56,6.56,0,0,0,2.81-.91c.33-.22.81-.43.5-1s-.47-1-1.18-1a6.7,6.7,0,0,0-1.81.57c-.9.29-1.73.38-2.32-.56C108.47,85.49,108.72,85.42,108.87,85.3Z"/>
                    <path class="cls-2" d="M108.54,80a1.8,1.8,0,0,0-2.45-1.13,21.39,21.39,0,0,0-3.4,1.22c-1.84,1.13-3.86,1.05-5.75,1.68a3.67,3.67,0,0,1-2.28-.08c1.89-1.89,3.39-3.88,6.27-4.16a26.31,26.31,0,0,0,2.92-.76.85.85,0,0,0,.64-.5c.39-1.07.87-1,1.9-.6,1.32.53,1.86,1.78,2.92,2.5.91.61.64,1-.17,1.45A5.48,5.48,0,0,0,108.54,80Z"/>
                    <path class="cls-2" d="M107.5,74.06c1-.84,1.94-1.62,3.4-1.41a2.8,2.8,0,0,0,1.58-.45,60.15,60.15,0,0,1,7.92-3.3c.44-.18.8-.42,1.12.22.2.4.67.36,1.07.25.21-.05.47-.36.63-.11.75,1.13,1.29.27,1.71-.23.83-1,1.24.28,1.88.34s-.42.67-.11,1.27c.16.32-.68.26-1.08.2a6.88,6.88,0,0,0-3.39.48c-1.77.63-3.57,1.84-5.26,1.86-3.26,0-6.19,2.12-9.5,1.3C107.29,74.33,107.25,74.19,107.5,74.06Z"/>
                    <path class="cls-55" d="M124.62,75.61c.89-.88,2-.62,3-.8s2.23-.12,3-1.06c.09-.1.18-.17.27-.08.76.67,1.88,1,2.17,2.12a1,1,0,0,1-.84,1.42c-1.38.3-2.85.35-4.08,1.17a.36.36,0,0,1-.52-.08c-.4-.47-.69-.71-1.17,0-.25.36-.81.27-.77-.34A2.4,2.4,0,0,0,124.62,75.61Z"/>
                    <path class="cls-56" d="M104.34,72.4c.2.35.24.61-.25.8-.81.31-1.59.68-2.37,1-.35.16-.54.12-.76-.24s0-.53.28-.7a10.62,10.62,0,0,1,2.81-1.21C104.32,72,104.39,72.15,104.34,72.4Z"/>
                    <path class="cls-57" d="M119.14,66.29c.23.06.57.14.91.24s.41.32.26.63c-.24.51-2.09.92-2.47.5-.22-.24-.52-.75-.43-.89C117.79,66.25,118.44,66.32,119.14,66.29Z"/>
                    <path class="cls-58" d="M104.32,86.74c.1-.27.21-.53.57-.49a9.42,9.42,0,0,0,3-.5c.07.06.09.11.07.17s-.06.08-.08.08c-.33.73-1.39.69-1.65,1.61-.07.24-.94-.31-1.46-.44C104.66,87,104.18,87.21,104.32,86.74Z"/>
                    <path class="cls-59" d="M104.32,86.74l.47.43c-.77-.27-1.06.59-1.66.71-.28-.27-.91.23-1-.45C102.62,86.43,103.59,86.94,104.32,86.74Z"/>
                    <path class="cls-60" d="M105,71.7l1.86-.65c-.37,1.16-1.09,1.07-1.86.85-.07,0-.09-.09-.07-.13S105,71.7,105,71.7Z"/>
                    <path class="cls-61" d="M110.05,71.57c-.57.18-.9.76-1.82.46C109,71.81,109.09,70.83,110.05,71.57Z"/>
                    <path class="cls-62" d="M103.54,92.49a1.12,1.12,0,0,1-1.53-.12A2,2,0,0,1,103.54,92.49Z"/>
                    <path class="cls-63" d="M102.14,87.43c.19.44.74.12,1,.45h-2.39C101.17,87.58,101.76,87.86,102.14,87.43Z"/>
                    <path class="cls-64" d="M107.9,86v-.25a1.36,1.36,0,0,1,1-.45l-.25.47Z"/>
                    <path class="cls-65" d="M105,71.7a1.33,1.33,0,0,1,0,.2l-.7.5-.29-.3C104.32,71.82,104.7,71.82,105,71.7Z"/>
                    <path class="cls-66" d="M107.5,74.06l0,.42c-.2,0-.49.36-.56.12S107.19,74.14,107.5,74.06Z"/>
                    <path class="cls-2" d="M38.7,112.15c-.3.27-.32,1.06-.82.82s-.26-.91-.34-1.37c-.31-1.78.93-2.24,2-2.94.22-.15.5-.37.55-.61.34-1.72,1.88-2.29,3.05-3.23.24-.18.7-.36.49-.69-.43-.68.17-.45.36-.44.7,0,1.26-.09,1.5-.86a.67.67,0,0,1,.45-.35c1.37-.16,2.07-1.74,3.54-1.66a.23.23,0,0,0,.2-.11c.8-1.24,2.39-1.32,3.33-2.32.5-.54,1.5-.53,1.63-1.51,0-.11.4-.25.61-.23s.16.3.21.48c.27.85-.09,1.71.06,2.65,1.23-.32,2.17-1.16,3.3-1.58.06.06.08.11.06.17s0,.08-.07.08c-1.31,1-1.79,2.58-2.64,3.89-.37.57-.83,1.06-1.19,1.64l0,0c-1.18.26-1.48,1.47-2.26,2.16-.57.5-.88,1.29-1.59,1.71-1.06.65-1.32,1.88-1.89,2.86-.82,1.39-1.58,2.81-2.45,4.18a3.24,3.24,0,0,1-1,1c-.37.26-.86.57-.54,1,.44.63-1.78.63-.26,1.35a18.85,18.85,0,0,1-1,1.89c-.3.46-.68,1-1.08,0-.32-.84-.94-.35-1.36-.07a11.32,11.32,0,0,0-1.92,2.27C39,123,38.4,124,37,123.79a5.53,5.53,0,0,0,1.91-3.74c.09-1.23.71-1.57,2.13-1.37.38,0,.52,0,.6-.29.22-.85,1.4-1.48.28-2.67-.39-.43.34-1.7.84-2.43.38-.56.71-1.13,1.05-1.71s.25-1.4,1.28-.82c.35.2.38-.33.34-.56-.14-1,.42-1.47,1.28-1.68.37-.09.79-.21.78-.6s-.49-.61-.89-.63a5.46,5.46,0,0,0-2.48-.07c-.25.1-.59.11-.61.46s-.32.64,0,.88.51-.08.73-.24l.66-.49c-.27,2.24-2.88,1.48-3.57,3.07.37.09.71.15,1,.25s.6.16.57.51-.34.62-.65.8-.54-.06-.68-.31a1.81,1.81,0,0,0-2.4-1C38.93,111.44,39.13,112,38.7,112.15Z"/>
                    <path class="cls-2" d="M27,110a12.48,12.48,0,0,1,3.82-3.87c1.77-1.29,3.45-2.69,5.18-4a4,4,0,0,1,.41-.24,53,53,0,0,0,5-2.41,3.75,3.75,0,0,0,1-.77A5.83,5.83,0,0,1,47,96.45c.83-.08,1.65-.92,2.58-1.24a18.21,18.21,0,0,1,3.06-1c.89-.14,1.18.25.88,1.11a2.06,2.06,0,0,1-1.18,1.12,20.27,20.27,0,0,0-3.12,1.49c-.25.18-.36.13-.56-.1-.32-.38-.51-.08-.52.22,0,.65-.5.83-1,1.1-2.51,1.5-4.92,3.15-7.33,4.82-1.94,1.35-3.28,3.32-5.32,4.53a29.16,29.16,0,0,0-3.41,2.71c-.16.13-.26.29-.1.51.61.82-.58.72-.69,1.23,0,.15-.65.35-1.15,0a3,3,0,0,1-1.58-2.2c0-.32,0-.87-.62-.85Z"/>
                    <path class="cls-2" d="M58.3,89.62a24,24,0,0,0-5.07.61c-.62.18-1.38.26-1.56,1.16-.05.29-.52.31-.82.42-2.05.77-4.16,1.35-6.19,2.18S40.78,96.11,38.78,97a47.86,47.86,0,0,0-7.76,4.7c-.7-1.23-.62-1.14.32-2a14.08,14.08,0,0,0,2.79-2.48c-.29-.47-.93.27-1-.38,0-.4.58-.25.71-.45a7.52,7.52,0,0,1,2.44-2,66.36,66.36,0,0,1,11.05-5.62c1.13-.45,2.26-1.22,3.6-.59.11,0,.31,0,.46-.09,2.77-.95,5.24-.12,7.63,1.25C59,90,58.58,89.65,58.3,89.62Z"/>
                    <path class="cls-2" d="M53,131.48a102.57,102.57,0,0,1,3.45-12.78A54.63,54.63,0,0,1,65,101.84c.19-.25.34-.81.72-.56s-.06.62-.2.92a9.53,9.53,0,0,1-1.6,2.34c-.76.86-1.4,1.85-.18,2.89.33.28.12.57,0,.85a14,14,0,0,0-.88,1.55c-.27.67-.28,1.29.52,1.7a.78.78,0,0,1,.2,1.37c-.54.39-.64,1.35-1.69,1.21-.43-.06-.64.69-.64,1.25,0,.93.32,2-1,2.42-.2.06-.27.62-.36,1-.16.56-.09,1.25-1,1.21-.37,0-.24.34-.23.55a5.83,5.83,0,0,1-.84,2.83,37.6,37.6,0,0,1-3.09,5.45,2.24,2.24,0,0,0-.49,2.4c.19.46-.58,1.32-.91,2C52.65,132.69,53,132.06,53,131.48Z"/>
                    <path class="cls-67" d="M53.59,112.6c-.23.57-.47,1.14-.71,1.72,0,.06,0,.22,0,.22-1.92.49-1.13,2.94-2.7,3.73-.64.33-.43,1.22-.74,1.82-.78,1.53-1.9,2.83-2.72,4.32-.58,1-1.83,1.37-2.39,2.63-.36-1.29.52-2,.7-3a7.19,7.19,0,0,1,1.85-4.14c.88-.84,1.26-2.19,1.88-3.3a5.06,5.06,0,0,1,1.41-1.9c.17-.1.38-.07.56-.14.64-.19.73-.74.83-1.28l1-.7A.78.78,0,0,1,53.59,112.6Z"/>
                    <path class="cls-9" d="M67.94,108.78c-.21,4.4-1,8.73-1.58,13.1-.28,2.16-.57,4.32-.79,6.48A9,9,0,0,1,65,130.3c-.62-.3-.27-.79-.24-1.22.38-6.32.44-12.68,2.18-18.84.22-.8.51-1.59.77-2.38C68.26,108.06,68,108.44,67.94,108.78Z"/>
                    <path class="cls-68" d="M54.44,110.71c-.73-.33-1-1.14-1.54-1.64-.12-.12.41-.78.88-.75.74,0,1.33,0,1.6-.86.15-.49.62-.12.94-.23.73-.24.06-1.46,1.1-1.48a1.63,1.63,0,0,0-.34-1.59c-.26-.22.11-.39.19-.34.5.36.75-1.18,1.15-.21a3,3,0,0,1,0,3.11,18.37,18.37,0,0,1-1.69,2.6c-.38.38-.61,1-1.31.37-.21-.19-.3-.1-.46.75C54.83,110.62,54.73,110.85,54.44,110.71Z"/>
                    <path class="cls-11" d="M60,104.21a1.14,1.14,0,0,0-.15-1.11c-.23-.25-.53-.6-.1-.91s.33-.83,1-.41c.48.29,1.68-.78,1.59-1.54a2.11,2.11,0,0,1,1.17-2.13c1-.6,1.85-1.53,2.94-2,.23-.1.25,0,.24.2-1.42,1.6-2.34,3.58-4.05,5-1,.81-1,2.42-2.39,3A.16.16,0,0,1,60,104.21Z"/>
                    <path class="cls-69" d="M72,123.08c.48-4.46-.15-9,.68-13.59a1.13,1.13,0,0,1,.56,1.24c-.07,3.07-.22,6.14-.59,9.2-.16,1.34-.25,2.69-.37,4,0,.23,0,.49-.26.62A2.34,2.34,0,0,1,72,123.08Z"/>
                    <path class="cls-68" d="M74.16,123.87c-.13.65.25,1.41-.51,2.14.2-1.27-.65-2.16-.51-3.3a2.21,2.21,0,0,1,.77-1.72c.52,0,.34.44.33.69A8.92,8.92,0,0,1,74.16,123.87Z"/>
                    <path class="cls-70" d="M74.16,123.87c-.19-1,.25-2-.25-2.88a25.66,25.66,0,0,1,.23-4.55c-.38-.31-.1-.87-.45-1.19.58-.35.67-.31.68.52,0,1.44,0,2.88,0,4.32C74.32,121.35,74.61,122.63,74.16,123.87Z"/>
                    <path class="cls-71" d="M24.79,106.14c.48-.27,1.23.29,1.49-.59.39.77-.13,2.3-.83,2.38-.23,0-1-.07-.88-.78.06-.35.16-.69.24-1Z"/>
                    <path class="cls-71" d="M59.39,129.29c-.7.12-.93,1.47-1.72.79-.59-.51.08-1.32.45-1.61C58.86,127.88,58.77,129.21,59.39,129.29Z"/>
                    <path class="cls-72" d="M56.22,134.63a13.09,13.09,0,0,1,1-2.87c0-.14.14-.32.25-.36s.33.17.39.34c.2.57-.12,1-.46,1.38s-1,.8-.49,1.51A.45.45,0,0,1,56.22,134.63Z"/>
                    <path class="cls-73" d="M66.7,96.26l-.24-.2c.64-1.25.7-1.3,1.82-1.36C68.05,95.56,67.36,95.89,66.7,96.26Z"/>
                    <path class="cls-74" d="M68.36,97.66a3.94,3.94,0,0,1,1.47-1.58c0,1.21-1.1,1.56-1.44,2.37A.68.68,0,0,1,68.36,97.66Z"/>
                    <path class="cls-75" d="M53.59,112.6c-.32,0-.65.24-1,0-.15-.68.36-1,.92-1.46A2.13,2.13,0,0,0,53.59,112.6Z"/>
                    <path class="cls-76" d="M72,123.08l0,1.5a16.6,16.6,0,0,1,0,2.82c-.63-.39-.22-1-.23-1.43C71.85,125,71.56,124,72,123.08Z"/>
                    <path class="cls-77" d="M58.27,95.26c.29-.86.7-1.05,1.22-1.09a.25.25,0,0,1,.25.32C59.55,95.08,58.94,94.83,58.27,95.26Z"/>
                    <path class="cls-78" d="M53,131.48c.16.55-.2,1.18.25,1.69l.43,1q0,.15-.15.15A2.38,2.38,0,0,1,53,131.48Z"/>
                    <path class="cls-79" d="M52.09,111.57c.21-.49.26-1.13,1.08-1.28C53.09,111,52.55,111.27,52.09,111.57Z"/>
                    <path class="cls-80" d="M62.41,121.65a1.44,1.44,0,0,1,.07,1.5A1.08,1.08,0,0,1,62.41,121.65Z"/>
                    <path class="cls-81" d="M60.62,93.56c.29-.35.56-.64,1-.56.06,0,.16.23.13.27A.9.9,0,0,1,60.62,93.56Z"/>
                    <path class="cls-74" d="M38.7,112.15c.2-.31.13-.76.5-1a2.17,2.17,0,0,1,0,.36c-.08.4.81.19.48.74S39.07,111.79,38.7,112.15Z"/>
                    <path class="cls-75" d="M56.22,134.63h.65a1,1,0,0,1-1.19.66C55.62,134.85,56.08,134.87,56.22,134.63Z"/>
                    <path class="cls-82" d="M60.11,93.14c-.58.32-.91.61-1.45.43A1.12,1.12,0,0,1,60.11,93.14Z"/>
                    <path class="cls-83" d="M64.77,129.08c.12.4-.14.87.24,1.22l-.27.8A2.76,2.76,0,0,1,64.77,129.08Z"/>
                    <path class="cls-84" d="M51.56,113.31c.21.82-.26,1.28-.87,1.67-.33-.36,0-.52.22-.71Z"/>
                    <path class="cls-2" d="M73.69,115.25c.78.16.32.78.45,1.19C73.28,116.31,73.81,115.66,73.69,115.25Z"/>
                    <path class="cls-85" d="M71.71,126c.14.46-.17,1,.23,1.43-.1.16-.26.6-.39.17A1.9,1.9,0,0,1,71.71,126Z"/>
                    <path class="cls-82" d="M38.56,113.32c.16,0,.31.1.3.28a.35.35,0,0,1-.36.36.34.34,0,0,1-.2-.22A.31.31,0,0,1,38.56,113.32Z"/>
                    <path class="cls-86" d="M67.94,108.78c-.1-.3.09-.67-.22-.92a.71.71,0,0,1,.42-.62C68.12,107.8,68.28,108.31,67.94,108.78Z"/>
                    <path class="cls-87" d="M68.36,97.66l0,.79c-.14.18-.45.28-.49.15C67.76,98.18,68.06,97.9,68.36,97.66Z"/>
                    <path class="cls-88" d="M58.3,89.62c.25-.06.55,0,.73-.24l.76.36A1.69,1.69,0,0,1,58.3,89.62Z"/>
                    <path class="cls-89" d="M54.44,110.71l.51-.27c-.1.43-.21.86-.38,1.61Z"/>
                    <path class="cls-90" d="M58.8,98.45V98.2c.22-.12.45-.26.71-.13a.23.23,0,0,1,.08.2C59.41,98.63,59.07,98.4,58.8,98.45Z"/>
                    <path class="cls-91" d="M54.13,95.21a.69.69,0,0,1,.22-1C54.51,94.64,54.25,94.87,54.13,95.21Z"/>
                    <path class="cls-92" d="M75.34,100.85V99.68h.22v1.17C75.49,101,75.42,101,75.34,100.85Z"/>
                    <path class="cls-93" d="M55,104c.22,0,.51,0,.39.38-.06.17-.25.38-.43.23s0-.41.06-.63Z"/>
                    <path class="cls-94" d="M27,109.94c0,.27.1.56-.11.79a.4.4,0,0,1-.26-.15c-.11-.34.12-.5.39-.63Z"/>
                    <path class="cls-95" d="M53.56,134.31a.28.28,0,0,1,.15-.15c.21.08.46.13.48.42,0,0-.09.14-.13.13A.52.52,0,0,1,53.56,134.31Z"/>
                    <path class="cls-96" d="M60,104.21l.26,0c-.16.23-.29.51-.63.57C59.5,104.43,59.8,104.35,60,104.21Z"/>
                    <path class="cls-97" d="M50.91,114.27c-.08.23-.15.47-.22.71l-.52-.25A.71.71,0,0,1,50.91,114.27Z"/>
                    <path class="cls-98" d="M75.34,100.85h.22a.82.82,0,0,1-.37.77C75,101.29,75.27,101.09,75.34,100.85Z"/>
                    <path class="cls-99" d="M78.34,124.3c.16.52.17.78,0,1.08C78.1,125,78.19,124.75,78.34,124.3Z"/>
                    <path class="cls-8" d="M51.7,112.41c-.12.08-.23.23-.37.24s-.14-.16-.06-.23a1.78,1.78,0,0,1,.36-.25Z"/>
                    <path class="cls-100" d="M61.39,100.79a1.72,1.72,0,0,1-.32.26c-.11,0-.27,0-.16-.19a.85.85,0,0,1,.33-.32C61.41,100.46,61.4,100.62,61.39,100.79Z"/>
                    <path class="cls-101" d="M54,38.84a2.3,2.3,0,0,0,.17,1.59c-1.55-1.1-3-2-3.22-3.89,0-.37-.35-.94.29-1s.93.21.91.91A1.83,1.83,0,0,0,54,38.57c.06.06.09.11.07.17S54.06,38.84,54,38.84Z"/>
                    <path class="cls-102" d="M56.77,41.81c-.26.39.06,1.33-.49,1.07-.39-.18-1.47.14-1.25-.75S56.18,42.19,56.77,41.81Z"/>
                    <path class="cls-103" d="M61.08,47c.44.33,1.38-.3,1.37.71,0,.28-.06.57-.38.67s-.45-.2-.56-.44S61.22,47.34,61.08,47Z"/>
                    <path class="cls-104" d="M59.07,42.86l.5,1.44a1.51,1.51,0,0,1-.73-1.18C58.92,43,58.93,42.89,59.07,42.86Z"/>
                    <path class="cls-105" d="M60.85,44.7a.48.48,0,0,1-.05.74.33.33,0,0,1-.28-.06A.6.6,0,0,1,60.85,44.7Z"/>
                    <path class="cls-106" d="M59.07,42.86l-.23.26A1.37,1.37,0,0,1,59,41.86C59.37,42.24,59,42.57,59.07,42.86Z"/>
                    <path class="cls-107" d="M54,38.84v-.27a.6.6,0,0,1,.4-.65C54.52,38.36,54.24,38.58,54,38.84Z"/>
                    <path class="cls-108" d="M63.82,37.37c-.3.12-.46-.19-.72-.22.1-.29.33-.27.55-.23S63.84,37.19,63.82,37.37Z"/>
                    <path class="cls-109" d="M63.23,36.5c-.11-.22-.15-.54,0-.64s.49.07.22.39A2,2,0,0,1,63.23,36.5Z"/>
                    <path class="cls-110" d="M86.61,50.12c.4-.24-.37-.8.25-1a.62.62,0,0,1,.5.21c.26.52-.21.71-.5,1C86.63,50.44,86.59,50.31,86.61,50.12Z"/>
                    <path class="cls-111" d="M86.61,50.12l.25.22c-.16.2-.34.58-.6.26S86.46,50.27,86.61,50.12Z"/>
                    <path class="cls-112" d="M76.52,43.94a.93.93,0,0,1-.24.25c-.17.08-.16-.09-.17-.18s0-.3.2-.34S76.5,43.73,76.52,43.94Z"/>
                    <path class="cls-113" d="M110.69,56.15c-.25.45-.6.38-1,.26A.65.65,0,0,1,110.69,56.15Z"/>
                    <path class="cls-114" d="M89.57,71.64a.81.81,0,0,1-1,.13C88.9,71.3,89.27,71.68,89.57,71.64Z"/>
                    <path class="cls-115" d="M50.11,104.66a3.18,3.18,0,0,1-2.24,2.25c-.23.07-.56.34-.62-.13,0-.23-.23-.63.34-.67S49,106,49,104.92C49,104.53,49.69,105,50.11,104.66Z"/>
                    <path class="cls-116" d="M55.07,99c0,.29-.25.35-.47.44s-.35,0-.35-.25,0-.47.36-.48A.47.47,0,0,1,55.07,99Z"/>
                    <path class="cls-117" d="M51.66,103.28c-.06.21.06.5-.23.61-.06,0-.26-.12-.25-.15.06-.32-.43-.76.2-.94C51.56,102.91,51.77,103,51.66,103.28Z"/>
                    <path class="cls-118" d="M50.79,100.88c.41.12.72.18.89.49,0,.07-.07.16-.12.17C51.13,101.63,50.88,101.44,50.79,100.88Z"/>
                    <path class="cls-119" d="M51.66,103.28l-.28-.48.79-.2C52.14,103,51.86,103.09,51.66,103.28Z"/>
                </g>
            </g>
        </g>
    </svg>

</template>

<script>
    export default {
        name: 'RecursoConcha',
    }
</script>

<style scoped>
    .cls-1 {
        fill: #2c2a7d;
    }

    .cls-2 {
        fill: #fefefe;
    }

    .cls-3 {
        fill: #5fb946;
    }

    .cls-4 {
        fill: #ecebf3;
    }

    .cls-5 {
        fill: #cfcee1;
    }

    .cls-6 {
        fill: #545395;
    }

    .cls-7 {
        fill: #869ccf;
    }

    .cls-8 {
        fill: #b0bedf;
    }

    .cls-9 {
        fill: #fdfdfe;
    }

    .cls-10 {
        fill: #fdfdfd;
    }

    .cls-11 {
        fill: #fcfcfd;
    }

    .cls-12 {
        fill: #fafafc;
    }

    .cls-13 {
        fill: #f9f9fb;
    }

    .cls-14 {
        fill: #f2f2f7;
    }

    .cls-15 {
        fill: #f8f8fa;
    }

    .cls-16 {
        fill: #f3f3f7;
    }

    .cls-17 {
        fill: #e5e5ef;
    }

    .cls-18 {
        fill: #e9e9f1;
    }

    .cls-19 {
        fill: #ebebf2;
    }

    .cls-20 {
        fill: #ebeaf2;
    }

    .cls-21 {
        fill: #e8e8f1;
    }

    .cls-22 {
        fill: #64b654;
    }

    .cls-23 {
        fill: #e1e1ec;
    }

    .cls-24 {
        fill: #f1f1f6;
    }

    .cls-25 {
        fill: #eff0f6;
    }

    .cls-26 {
        fill: #f2f2f6;
    }

    .cls-27 {
        fill: #e4e4ee;
    }

    .cls-28 {
        fill: #e8e8f0;
    }

    .cls-29 {
        fill: #e1e0ec;
    }

    .cls-30 {
        fill: #e2e2ed;
    }

    .cls-31 {
        fill: #e6e5ef;
    }

    .cls-32 {
        fill: #565597;
    }

    .cls-33 {
        fill: #5b599a;
    }

    .cls-34 {
        fill: #a7a6c8;
    }

    .cls-35 {
        fill: #d0d0e2;
    }

    .cls-36 {
        fill: #d5d5e5;
    }

    .cls-37 {
        fill: #9e9dc3;
    }

    .cls-38 {
        fill: #8483b4;
    }

    .cls-39 {
        fill: #b0afce;
    }

    .cls-40 {
        fill: #9796bf;
    }

    .cls-41 {
        fill: #bcbbd5;
    }

    .cls-42 {
        fill: #a9a8ca;
    }

    .cls-43 {
        fill: #7e7daf;
    }

    .cls-44 {
        fill: #8887b6;
    }

    .cls-45 {
        fill: #47458d;
    }

    .cls-46 {
        fill: #4b4a90;
    }

    .cls-47 {
        fill: #fcfbfc;
    }

    .cls-48 {
        fill: #9c9bc1;
    }

    .cls-49 {
        fill: #9a99c0;
    }

    .cls-50 {
        fill: #8382b2;
    }

    .cls-51 {
        fill: #595798;
    }

    .cls-52 {
        fill: #bebed7;
    }

    .cls-53 {
        fill: #8180b1;
    }

    .cls-54 {
        fill: #e7e7f0;
    }

    .cls-55 {
        fill: #fdfefd;
    }

    .cls-56 {
        fill: #f8fbf7;
    }

    .cls-57 {
        fill: #fafcf9;
    }

    .cls-58 {
        fill: #f7fbf6;
    }

    .cls-59 {
        fill: #eaf6e7;
    }

    .cls-60 {
        fill: #f0f8ee;
    }

    .cls-61 {
        fill: #e2f2de;
    }

    .cls-62 {
        fill: #edf7eb;
    }

    .cls-63 {
        fill: #b5dfaa;
    }

    .cls-64 {
        fill: #bce1b2;
    }

    .cls-65 {
        fill: #def0d9;
    }

    .cls-66 {
        fill: #7ac666;
    }

    .cls-67 {
        fill: #fdfefe;
    }

    .cls-68 {
        fill: #fcfdfd;
    }

    .cls-69 {
        fill: #fbfcfd;
    }

    .cls-70 {
        fill: #ccd5ea;
    }

    .cls-71 {
        fill: #fafbfd;
    }

    .cls-72 {
        fill: #eceff7;
    }

    .cls-73 {
        fill: #f4f6fa;
    }

    .cls-74 {
        fill: #f0f2f8;
    }

    .cls-75 {
        fill: #eff2f8;
    }

    .cls-76 {
        fill: #f1f4f9;
    }

    .cls-77 {
        fill: #f7f8fb;
    }

    .cls-78 {
        fill: #e0e5f2;
    }

    .cls-79 {
        fill: #e4e9f4;
    }

    .cls-80 {
        fill: #f0f3f9;
    }

    .cls-81 {
        fill: #e5e9f4;
    }

    .cls-82 {
        fill: #f2f4f9;
    }

    .cls-83 {
        fill: #e1e6f3;
    }

    .cls-84 {
        fill: #a3b4db;
    }

    .cls-85 {
        fill: #d7deef;
    }

    .cls-86 {
        fill: #cad3ea;
    }

    .cls-87 {
        fill: #f9fafc;
    }

    .cls-88 {
        fill: #dce2f0;
    }

    .cls-89 {
        fill: #f1f3f9;
    }

    .cls-90 {
        fill: #dee3f1;
    }

    .cls-91 {
        fill: #bdc9e5;
    }

    .cls-92 {
        fill: #c7d1e8;
    }

    .cls-93 {
        fill: #e7ebf5;
    }

    .cls-94 {
        fill: #d2daed;
    }

    .cls-95 {
        fill: #cfd7eb;
    }

    .cls-96 {
        fill: #d0d8ec;
    }

    .cls-97 {
        fill: #eef1f8;
    }

    .cls-98 {
        fill: #9daed8;
    }

    .cls-99 {
        fill: #f8f8fc;
    }

    .cls-100 {
        fill: #dfe4f2;
    }

    .cls-101 {
        fill: #333181;
    }

    .cls-102 {
        fill: #49488f;
    }

    .cls-103 {
        fill: #3d3b87;
    }

    .cls-104 {
        fill: #6866a1;
    }

    .cls-105 {
        fill: #7b7aad;
    }

    .cls-106 {
        fill: #373584;
    }

    .cls-107 {
        fill: #9594be;
    }

    .cls-108 {
        fill: #42408a;
    }

    .cls-109 {
        fill: #2e2c7e;
    }

    .cls-110 {
        fill: #6fc059;
    }

    .cls-111 {
        fill: #86ca73;
    }

    .cls-112 {
        fill: #62ba49;
    }

    .cls-113 {
        fill: #6bbf54;
    }

    .cls-114 {
        fill: #addba1;
    }

    .cls-115 {
        fill: #8fa3d2;
    }

    .cls-116 {
        fill: #94a7d4;
    }

    .cls-117 {
        fill: #94a7d5;
    }

    .cls-118 {
        fill: #ced6eb;
    }

    .cls-119 {
        fill: #b4c1e1;
    }
</style>
